import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../modules/shared/services/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthGuard implements CanActivate {

  private jwtHelper = new JwtHelperService();

  constructor(public router: Router, private auth: AuthService, private toast: ToastrService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data.roles;

    if (!this.auth.isAuthenticated()) {
      this.toast.error('Sie sind nicht mehr eingeloggt. Bitte loggen Sie sich erneut ein');
      this.router.navigate(['login']);
    }
    
    const jwt = this.auth.getJwtToken();
    const payload = this.jwtHelper.decodeToken(jwt);
    const roles = payload.sub.roles;
    let roleMatch = false;
    roles.forEach(oneRole => {
      if (allowedRoles.includes(oneRole)) {
       roleMatch = true;
      }
    });

    if (roleMatch) {
      return true;
    }

    this.toast.error('Fehlende Berechtigung um die Route aufzurufen');
    return false;
  }
}